"use client"

import dynamic from "next/dynamic";
import * as React from "react"
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { buttonVariants } from "./fun-ui/Button";
import Image from "next/image";
import { fetchCommonConfig } from "@/lib/common-config-client";

const ReactMarkdown = dynamic(() => import("react-markdown"), { ssr: false });

type SystemMaintenanceConfig = {
  content: string;
  title: string;
  maintenance: boolean;
  whitelist: string[];
};


export function SystemMaintenance({ children }: {
  children?: React.ReactNode;
}) {
  const pathname = usePathname();
  const [value, setValue] = useState<SystemMaintenanceConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchCommonConfig<SystemMaintenanceConfig>("system_maintenance", { silent: true }).then((config) => {
      if (!cancelled) {
        setValue(config);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (value?.maintenance) {
    const key = `pc:${pathname.replace(/^\//, '') || 'default'}`;
    const all = 'pc:*';
    // 不在白名单
    if (!(value.whitelist.includes(key) || value.whitelist.includes(all))) {
      return (
        <div className="flex flex-col h-screen w-screen items-center justify-center">
          <Image width={395} height={305} alt="系统维护中" src="https://oss.findinai.cn/storage/20250118/5dd6d11c413765f64a2fed60bf227b40.gif" />
          <h1 className="text-[32px] mb-3 font-medium">{value.title}</h1>
          <ReactMarkdown>{value.content}</ReactMarkdown>
          <Link
            href="/"
            className={cn(
              buttonVariants({ variant: 'default' }),
              "py-0 px-10 rounded-full cursor-pointer mt-10",
            )}
          >返回首页</Link>
        </div>
      )
    }
  }

  return children;
}
